module.exports = __webpack_public_path__ + "317a4210ef29a41c456503c8e5951448.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/fonts/roboto-slab-thin.ttf
// module id = ./src/components/main/fonts/roboto-slab-thin.ttf
// module chunks = index